'use client';

import React, { useRef } from 'react';
import { useTranslations } from 'next-intl';
import { useElementScroll } from '@/shared/hooks/dom/scroll/useElementScroll';
import { TabItem } from './TabItem';
import { ReviewsMood } from '@/entities/review/model/types';
import type { IReviewStats } from '@/entities/review/model/types';
interface Props {
  setFilter: React.Dispatch<React.SetStateAction<ReviewsMood>>;
  filter: ReviewsMood;
  stats: IReviewStats;
}
export const TabList: React.FC<Props> = props => {
  const {
    setFilter,
    filter,
    stats
  } = props;
  const containerRef = useRef<HTMLDivElement>(null);
  const {
    scrollToElement
  } = useElementScroll(containerRef);
  const t = useTranslations('doctor.reviews');
  const handleTabClick = (mood: ReviewsMood, index: number) => {
    setFilter(mood);
    scrollToElement(index);
  };
  return <div ref={containerRef} className="mb-4 flex space-x-2 overflow-x-auto scroll-width-none" data-sentry-component="TabList" data-sentry-source-file="TabList.tsx">
      <TabItem onClick={() => handleTabClick(ReviewsMood.Any, 0)} active={filter === ReviewsMood.Any} data-sentry-element="TabItem" data-sentry-source-file="TabList.tsx">
        {`${t('all')}`} {stats.allCount}
      </TabItem>

      <TabItem onClick={() => handleTabClick(ReviewsMood.Positive, 1)} active={filter === ReviewsMood.Positive} disabled={stats.positiveCount === 0} data-sentry-element="TabItem" data-sentry-source-file="TabList.tsx">
        {`${t('positive')}`} {stats.positiveCount}
      </TabItem>

      <TabItem onClick={() => handleTabClick(ReviewsMood.Negative, 2)} active={filter === ReviewsMood.Negative} disabled={stats.negativeCount === 0} data-sentry-element="TabItem" data-sentry-source-file="TabList.tsx">
        {`${t('negative')}`} {stats.negativeCount}
      </TabItem>
    </div>;
};